
<template>
  <multiselect
    :value="value"
    :options="datalist"
    :multiple="true"
    label="labelText"
    track-by="labelText"
    :maxHeight="200"
    @input="OninputChanged"
    :hideSelected="true"
    :showLabels="false"
    placeholder
  ></multiselect>
</template>


<script>
import Multiselect from 'vue-multiselect'
export default {
  name: 'XVmultiselect',

  components: {
    Multiselect
  },
  inheritAttrs: false,
  props: {
    focus: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    datalist: {
      type: Array,
      reuired: true
    },
    value: {
      default: []
    },
    placeholder: {
      type: String,
      default: ''
    },
    formdata: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      checkedindex: ''
    }
  },
  mounted: function() {
    if ($('html').hasClass('mobile')) {
      this.hasMobile = true
    }
  },
  methods: {
    selectchanged: function(val) {
      let dliobj = this.datalist.filter(v => {
        return String(v.value) === String(val)
      })[0]
      this.$emit('input', val)
      this.$emit('change', val)
      this.$emit('formvaluechanged', {
        type: this.$vnode.componentOptions.tag,
        value: dliobj.value,
        labelText: dliobj.labelText,
        id: this.id,
        formdata: this.formdata
      })
    },
    OninputChanged(value) {
      this.$emit('input', value)
    }
  },
  computed: {
    // multiselectvalue: {
    //   get: function() {
    //     return this.value.map(v => {
    //       return this.datalist.find(r => r.value === v)
    //     })
    //   },
    //   set: function(value) {
    //     // console.log(value)
    //   }
    // }
  }
}
</script>
